module.exports = __webpack_public_path__ + "static/media/logout.cafb2b40.svg";